<div class="row">
  <div class="col">
    <h2>Confirmation</h2>
    <p class="pt-3">
      Thank you! You have successfully submitted your credit application. A
      representative from Sims will contact you within one business day.
    </p>
    <ng-container *ngIf="branch">
      <p class="branch-information">
        For reference, your application was sent to our
        {{ branch.LocationName }} store, if you have any questions please
        contact them.
      </p>
      <p>
        Questions? Contact {{ branch.LocationName }} - we&rsquo;re here to help!
      </p>
    </ng-container>
  </div>
</div>
<div *ngIf="branch" class="row mt-3 branch-information">
  <div class="col-12 col-md-6 col-lg-4">
    <app-branch-selection [branch]="branch"></app-branch-selection>
  </div>
</div>
<div class="row my-5">
  <div class="col-12 col-md-6">
    <button class="btn btn-primary" (click)="onExitApplication()">
      <small> Clear Application </small>
    </button>
  </div>
</div>
